import { render, staticRenderFns } from "./submit-task-category.vue?vue&type=template&id=c0b8aa36&"
import script from "./submit-task-category.vue?vue&type=script&lang=js&"
export * from "./submit-task-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports